'use client';

import { useAgreements } from '@vimond/services/default-payment-provider/hooks/useAgreements';
import { useMemo } from 'react';
import { useAuthentication } from './useAuthentication';

/**
 * Hook to fetch and manage active subscriptions for the current user.
 * @returns Object containing active subscriptions, a flag indicating if all agreements are inactive,
 * loading state, and a refetch function.
 */
const useActiveSubscriptions = () => {
  const { jwt } = useAuthentication();

  const { agreements, loading, refetch } = useAgreements(jwt ?? '');

  const allAgreementsAreInactive = useMemo(() => {
    const now = Date.now();
    return (
      agreements.length === 0 ||
      agreements.every(
        (agreement) =>
          agreement.status === 'ENDED' ||
          new Date(agreement.endDate).getTime() < now,
      )
    );
  }, [agreements]);

  return useMemo(
    () => ({
      activeSubscriptions: agreements,
      allAgreementsAreInactive,
      loading,
      refetch,
    }),
    [agreements, allAgreementsAreInactive, loading, refetch],
  );
};

export default useActiveSubscriptions;
